import React, { useState, useEffect, useRef } from "react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ThemeProvider } from "@mui/material/styles";
import { theme } from "../../pages/doctor-console/StyledComponents";
import "./ShowConfirmDialog.scss";

const PromptDialog = ({ message, onConfirm, onCancel }) => {
  const [inputValue, setInputValue] = useState("");
  const inputRef = useRef(null);

  useEffect(() => {
    // Focus on the input field when the component is mounted
    inputRef.current.focus();
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <div className="prompt-dialog">
        <p>{message}</p>
        <input
          type="text"
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          ref={inputRef}
          className="prompt-input"
        />
        <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}>
          <button onClick={() => onConfirm(inputValue)} className="button button-contained">
            Ok
          </button>
          <button onClick={onCancel} className="button button-contained-cancel">
            Cancel
          </button>
        </div>
      </div>
    </ThemeProvider>
  );
};

const showPromptDialog = (message) => {
  return new Promise((resolve) => {
    const onConfirm = (value) => {
      resolve(value);
      toast.dismiss();
    };

    const onCancel = () => {
      resolve(null);
      toast.dismiss();
    };

    toast(
      <ThemeProvider theme={theme}>
        <PromptDialog
          message={message}
          onConfirm={onConfirm}
          onCancel={onCancel}
        />
      </ThemeProvider>,
      {
        autoClose: false,
        closeOnClick: false,
        draggable: false,
      }
    );
  });
};

export default showPromptDialog;
